import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        font-size: 16px;\n        line-height: 110%;\n        margin-top: 10px;\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      margin-bottom: 5px;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  > div {\n    margin-bottom: 20px;\n    ", "\n    &:last-child {\n      margin-bottom: 0px;\n      font-size: 20px;\n      font-family: ", ";\n      padding-top: 20px;\n      margin-top: 20px;\n      border-top: 1px solid rgba(0, 0, 0, 0.1);\n      span {\n        &:last-child {\n          color: ", ";\n        }\n      }\n      ", "\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    & span:last-child {\n      font-weight: 500;\n    }\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font: 16px ", ";\n  line-height: 1.5em;\n  margin-bottom: 5px;\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Wrapper = styled.div(_templateObject());
export var CostLine = styled.div(_templateObject2(), function (props) {
  return props.theme.typography.extraFontFamily;
}, media.xxLargeScreen(_templateObject3()), media.smallScreen(_templateObject4()));
export var Costs = styled.div(_templateObject5(), media.xxLargeScreen(_templateObject6()), function (props) {
  return props.theme.typography.baseFontFamily;
}, function (props) {
  return props.theme.colors.red;
}, media.xxLargeScreen(_templateObject7()));